import { render, staticRenderFns } from "./TituloCat.vue?vue&type=template&id=485bc7e3&scoped=true&"
import script from "./TituloCat.vue?vue&type=script&lang=js&"
export * from "./TituloCat.vue?vue&type=script&lang=js&"
import style0 from "./TituloCat.vue?vue&type=style&index=0&id=485bc7e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485bc7e3",
  null
  
)

export default component.exports